// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__16sTk","alertIcon":"ConfirmModal_alertIcon__3DyYq"};